// extracted by mini-css-extract-plugin
export default {"commentField":"FlagDialog_commentField__DYY6B"};